export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    loading: state => state.loading
  },
  mutations: {
    setAll(state, components) {
      state.all = components
      state.loading = false
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit, state }, { profileQualification } = {}) {
      this.$authorize('edit', 'ProfileQualification')

      state.loading = true
      return Vue.$http
        .get(`admin/profile_qualifications/${profileQualification.id}/components`)
        .then(response => commit('setAll', response.data), error => (state.loading = false))
    },
    create({ commit, dispatch }, component) {
      this.$authorize('create', 'ProfileQualification')

      return Vue.$http
        .post(`admin/profile_qualifications/${component.profileQualification.id}/components`, { component })
        .then(
          response => {
            commit('snackbar', { text: 'Component created', type: 'success' }, { root: true })
            dispatch('admin/profileQualifications/fetch', component.profileQualification.id, { root: true })
          },
          error => {
            commit('snackbar', { text: 'Component could not be created', type: 'error' }, { root: true })
          }
        )
    },
    update({ commit, dispatch }, component) {
      this.$authorize('edit', 'ProfileQualification')

      return Vue.$http
        .patch(`admin/profile_qualifications/${component.profileQualification.id}/components/${component.id}`, {
          component
        })
        .then(
          response => {
            commit('snackbar', { text: 'Component updated', type: 'success' }, { root: true })
            dispatch('admin/profileQualifications/fetch', component.profileQualification.id, { root: true })
          },
          error => {
            commit('snackbar', { text: 'Component could not be updated', type: 'error' }, { root: true })
            return Object.assign(component, error.response.data)
          }
        )
    },
    destroy({ commit, dispatch }, component) {
      this.$authorize('edit', 'ProfileQualification')

      return Vue.$http
        .delete(`admin/profile_qualifications/${component.profileQualification.id}/components/${component.id}`)
        .then(
          response => {
            commit('snackbar', { text: 'Qualification component was removed', type: 'success' }, { root: true })
            dispatch('admin/profileQualifications/fetch', component.profileQualification.id, { root: true })
          },
          error =>
            commit('snackbar', { text: 'Qualification component could not be removed', type: 'error' }, { root: true })
        )
    }
  }
}
